/**
 * Age Band Definitions
 * Bands: Sprout (4-6), Explorer (7-9), Adventurer (10-12)
 */
export const AGE_BANDS = {
  SPROUT: {
    id: 'sprout',
    label: 'Sprout',
    emoji: '🌱',
    range: [4, 6],
    color: 'from-green-400 to-teal-400',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-300',
    textColor: 'text-green-700',
    questDifficulty: 'easy',
    fontSize: 'text-2xl',
    gridCols: 'grid-cols-1 sm:grid-cols-2',
    description: 'Simple counting, colors & shapes',
    allowedAreas: ['starter-jungle'],
    unlockedAreas: ['starter-jungle'],
  },
  EXPLORER: {
    id: 'explorer',
    label: 'Explorer',
    emoji: '🔭',
    range: [7, 9],
    color: 'from-blue-400 to-indigo-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-300',
    textColor: 'text-blue-700',
    questDifficulty: 'medium',
    fontSize: 'text-xl',
    gridCols: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    description: 'Math, patterns & science labs',
    allowedAreas: ['starter-jungle', 'thinking-temple'],
    unlockedAreas: ['starter-jungle', 'thinking-temple'],
  },
  ADVENTURER: {
    id: 'adventurer',
    label: 'Adventurer',
    emoji: '⚔️',
    range: [10, 12],
    color: 'from-purple-500 to-pink-500',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-300',
    textColor: 'text-purple-700',
    questDifficulty: 'hard',
    fontSize: 'text-lg',
    gridCols: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
    description: 'Multiplication, logic & advanced challenges',
    allowedAreas: ['starter-jungle', 'thinking-temple', 'multiplication-temple', 'wisdom-peaks'],
    unlockedAreas: ['starter-jungle', 'thinking-temple', 'multiplication-temple', 'wisdom-peaks'],
  },
};

export function getAgeBand(age) {
  if (age >= 4 && age <= 6) return AGE_BANDS.SPROUT;
  if (age >= 7 && age <= 9) return AGE_BANDS.EXPLORER;
  if (age >= 10 && age <= 12) return AGE_BANDS.ADVENTURER;
  return AGE_BANDS.SPROUT;
}

export function isAreaAllowed(areaId, age) {
  const band = getAgeBand(age);
  return band.allowedAreas.includes(areaId);
}

export function getRecommendedDifficulty(age) {
  return getAgeBand(age).questDifficulty;
}

export const ACHIEVEMENTS = [
  { id: 'first_quest', label: 'First Steps', emoji: '👣', description: 'Complete your first quest', condition: (s) => s.completedQuests.length >= 1 },
  { id: 'five_quests', label: 'Quest Hunter', emoji: '🏹', description: 'Complete 5 quests', condition: (s) => s.completedQuests.length >= 5 },
  { id: 'ten_quests', label: 'Legend', emoji: '🏆', description: 'Complete 10 quests', condition: (s) => s.completedQuests.length >= 10 },
  { id: 'hundred_tokens', label: 'Token Collector', emoji: '🪙', description: 'Earn 100 tokens', condition: (s) => s.tokens >= 100 },
  { id: 'five_hundred_tokens', label: 'Treasure Chest', emoji: '💰', description: 'Earn 500 tokens', condition: (s) => s.tokens >= 500 },
  { id: 'perfect_accuracy', label: 'Sharpshooter', emoji: '🎯', description: 'Reach 90%+ accuracy', condition: (s) => s.gameStats.totalAnswers > 5 && (s.gameStats.correctAnswers / s.gameStats.totalAnswers) >= 0.9 },
  { id: 'level_5', label: 'Rising Star', emoji: '⭐', description: 'Reach Level 5', condition: (s) => s.level >= 5 },
  { id: 'level_10', label: 'Jungle Master', emoji: '🦁', description: 'Reach Level 10', condition: (s) => s.level >= 10 },
];

export function getEarnedAchievements(state) {
  return ACHIEVEMENTS.filter(a => a.condition(state));
}